<template>
  <div class="text-h1">
		<div class="d-flex justify-center pt-12"><p class="text--secondary">EROR <span class="dr-eror-text-container">404</span></p></div>
		<div class="d-flex justify-center pt-12 text--secondary">PAGE NOT FOUND</div>
	</div>
</template>
<script>
export default {
  
}
</script>
<style>
.dr-eror-text-container {
	color: #EF5350;
}
</style>